import { render } from "./ResetSshKeyPair.vue?vue&type=template&id=40c1fd03&scoped=true"
import script from "./ResetSshKeyPair.vue?vue&type=script&lang=js"
export * from "./ResetSshKeyPair.vue?vue&type=script&lang=js"

import "./ResetSshKeyPair.vue?vue&type=style&index=0&id=40c1fd03&scoped=true&lang=scss"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c1fd03"]])

export default __exports__